import { useState, useEffect } from "react";
import "./style.css";
import api from "../../../services/api.js";
import Modal from "react-modal";
import PopUp from "../../../componente/popup/index.jsx";
import PopUp1 from "../../../componente/popup/index.jsx";
import { useAppContext } from '../../../context/AppContext.js';

function CadCheckList() {
  const { DateTime } = require("luxon");

  // Função para calcular o primeiro dia do mês
  const getFirstDayOfMonth = () => {
    const dt = new Date();
    return `${dt.getFullYear()}-${(dt.getMonth() + 1).toString().padStart(2, "0")}-01`;
  };

  // Função para calcular a data atual
  const getCurrentDate = () => {
    const dt = new Date();
    return `${dt.getFullYear()}-${(dt.getMonth() + 1).toString().padStart(2, "0")}-${dt.getDate().toString().padStart(2, "0")}`;
  };

  const [lista, setlista] = useState([]);
  const [listaGestor, setListaGestor] = useState([]);
  const [listaColaborador, setListaColaborador] = useState([]);
  const [abusca, setabusca] = useState("");
  const [dt1, setdt1] = useState(getFirstDayOfMonth);
  const [dt2, setdt2] = useState(getCurrentDate);
  const [showform, setshowform] = useState(false);

  const [codchecklist, setCodCheckList] = useState(0);
  const [codgestor, setCodGestor] = useState(0);
  const [codcolaborador, setCodColaborador] = useState(0);
  const [tipoperiodicidade, setTipoPeriodicidade] = useState("");
  const [dttarefa, setDtTarefa] = useState("");
  const [diastolerancia, setDiasTolerancia] = useState(0);
  const [qtdetarefa, setQtdeTarefa] = useState(0);
  const [coinssomar, setCoinsSomar] = useState(0);
  const [coinssubtrair, setCoinsSubtrair] = useState(0);
  const [tarefa, setTarefa] = useState("");

  const [edtcodequipe, setedtcodequipe] = useState(0);
  const [edtcodsetor, setedtcodsetor] = useState(0);
  const [edtcodfuncao, setedtcodfuncao] = useState(0);
  const [listaequipe, setlistaequipe] = useState([]);
  const [listasetor, setlistasetor] = useState([]);
  const [listafuncao, setlistafuncao] = useState([]);

  const [novo, setnovo] = useState(false);

  const [isOpen, setIsOpen] = useState(false);
  const [isOpen1, setIsOpen1] = useState(false);

  const { codassinante, selectedCompany, accessKey } = useAppContext();

  const [selectedItems, setSelectedItems] = useState([]);

  const handleOpen = (cad) => {
    setCodCheckList(cad.codchecklist);
    setIsOpen(true);
  };

  const handleConfirma = () => {
    setIsOpen(false);
    Excluir();
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleCloneOpen = (cad) => {
    setCodCheckList(0);
    setCodGestor(cad.codgestor);
    setCodColaborador(cad.codcolaborador);
    setedtcodequipe(cad.codequipe);
    setedtcodfuncao(cad.codfuncao);
    setedtcodsetor(cad.codsetor);
    setTipoPeriodicidade(cad.tipoperiodicidade);

    const dt = DateTime.fromISO(cad.dttarefa)
      .plus({ hours: 3 })
      .toFormat("yyyy-MM-dd");

    setDtTarefa(dt);

    setDiasTolerancia(cad.diastolerancia);
    setQtdeTarefa(cad.qtdetarefa);
    setCoinsSomar(cad.coinssomar);
    setCoinsSubtrair(cad.coinssubtrair);
    setTarefa(cad.tarefa);

    ListarSupervisor();
    ListarColaborador();
    ListarEquipe();
    ListarSetor();
    ListarFuncao();

    setIsOpen1(true);
  };

  const handleCloneConfirma = () => {
    setshowform(true);
    setnovo(true);

    setIsOpen1(false);
  };

  const handleCloneClose = () => {
    setIsOpen1(false);
  };

  function ListarCheckList() {
    api
      .get("/v1/cadastro/checklist", {
        params: {
          busca: abusca,
          codassinante: codassinante,
          codempresa: selectedCompany,
          dt1,
          dt2
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(function (response) {
        setlista(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  useEffect(
    function () {
      ListarCheckList();
    },
    [showform, abusca, dt1, dt2, selectedCompany]
  );

  function ListarSupervisor() {
    api
      .get("v1/cadastro/supervisor", {
        params: {
          busca: "",
          codassinante,
          codempresa: selectedCompany
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(function (response) {
        setListaGestor(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function ListarColaborador() {
    api
      .get("v1/cadastro/colaborador", {
        params: {
          busca: "",
          codassinante,
          codempresa: selectedCompany
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(function (response) {
        setListaColaborador(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function Cadastrar() {
    const dt = new Date();
    const date =
      dt.getFullYear() +
      "-" +
      (dt.getMonth() + 1).toString().padStart(2, "0") +
      "-" +
      dt.getDate().toString().padStart(2, "0");
    let time =
      dt.getHours().toString().padStart(2, "0") +
      ":" +
      dt.getMinutes().toString().padStart(2, "0") +
      ":" +
      dt.getSeconds().toString().padStart(2, "0");;
    let dtcadastro = date + "T" + time;

    api
      .post(
        "/v1/cadastro/checklist",
        {
          dtlancamento: dtcadastro,
          codgestor,
          codcolaborador,
          codequipe: edtcodequipe,
          codsetor: edtcodsetor,
          codfuncao: edtcodfuncao,
          tipoperiodicidade,
          dttarefa,
          diastolerancia,
          qtdetarefa,
          coinssomar,
          coinssubtrair,
          tarefa,
          excluido: "N",
          codassinante,
          codempresa: selectedCompany
        },
        {
          headers: {
            Authorization: `Bearer ${accessKey}`,
          },
        }
      )
      .then(() => {
        ListarCheckList();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function Excluir() {
    api
      .delete("v1/cadastro/checklist", {
        params: {
          codchecklist,
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(() => {
        ListarCheckList();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function Salvar() {
    Cadastrar();
    setshowform(false);
  }

  function closeModal() {
    setshowform(false);
  }

  function openModalNovo() {
    setshowform(true);
    setnovo(true);

    setCodCheckList(0);
    setCodGestor(0);
    setCodColaborador(0);
    setedtcodequipe(0);
    setedtcodfuncao(0);
    setedtcodsetor(0);
    setTipoPeriodicidade("");

    const dt = new Date();
    const date =
      dt.getFullYear() +
      "-" +
      (dt.getMonth() + 1).toString().padStart(2, "0") +
      "-" +
      dt.getDate().toString().padStart(2, "0");
    let dtcadastro = date;

    setDtTarefa(dtcadastro);
    setDiasTolerancia(1);
    setQtdeTarefa(1);
    setCoinsSomar(0);
    setCoinsSubtrair(0);
    setTarefa("");

    ListarSupervisor();
    ListarColaborador();
    ListarEquipe();
    ListarSetor();
    ListarFuncao();
  }

  function FormataDataHora(props) {
    return props
      ? DateTime.fromISO(props)
        .plus({ hours: 3 })
        .toFormat("dd/MM/yyyy HH:mm:ss")
      : null;
  }

  function FormataData(props) {
    return props
      ? DateTime.fromISO(props)
        .plus({ hours: 3 })
        .toFormat("dd/MM/yyyy")
      : null;
  }

  const handleEquipeChange = (event) => {
    setedtcodequipe(event.target.value); // Armazena "null" para todas as empresas
  };

  const handleSetorChange = (event) => {
    setedtcodsetor(event.target.value); // Armazena "null" para todas as empresas
  };

  const handleFuncaoChange = (event) => {
    setedtcodfuncao(event.target.value); // Armazena "null" para todas as empresas
  };

  function ListarEquipe() {

    api
      .get("/v1/cadastro/equipe", {
        params: {
          busca: "",
          codassinante: codassinante,
          codempresa: selectedCompany
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(function (response) {
        setlistaequipe(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function ListarSetor() {

    api
      .get("/v1/cadastro/setor", {
        params: {
          busca: "",
          codassinante: codassinante,
          codempresa: selectedCompany
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(function (response) {
        setlistasetor(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function ListarFuncao() {
    api
      .get("v1/cadastro/funcao", {
        params: {
          busca: "",
          codassinante: codassinante,
          codempresa: selectedCompany
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(function (response) {
        setlistafuncao(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  const handleCheckboxChange = (id) => {
    setSelectedItems((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const handleSelectAll = () => {
    if (selectedItems.length === lista.length) {
      setSelectedItems([]);
    } else {
      setSelectedItems(lista.map((item) => item.codchecklist));
    }
  };

  // excluir selecionados
  const ExcluirSelecionados = () => {
    if (selectedItems.length === 0) return;

    api
      .delete("v1/cadastro/checklist/excluirvarios", {
        params: {
          codigos: selectedItems.join(","), // ex: "1,2,3"
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(() => {
        ListarCheckList();
        setSelectedItems([]); // limpa seleção
      })
      .catch((err) => {
        console.log("ops! ocorreu um erro: " + err);
      });
  };

  return (
    <>
      <div className="app-container">
        <div className="container-fluid">
          <div>
            <div>
              <PopUp isOpen={isOpen} onClose={handleClose}>
                <h2>Verificação</h2>
                <p>Tem certeza que deseja excluir esse registro?</p>

                <div className="row">
                  <div className="col-12 mt-3 d-flex justify-content-end">
                    <button
                      className="btn btn-primary me-2"
                      onClick={handleConfirma}
                    >
                      Sim
                    </button>
                    <button className="btn btn-danger" onClick={handleClose}>
                      Não
                    </button>
                  </div>
                </div>
              </PopUp>

              <PopUp1 isOpen={isOpen1} onClose={handleCloneClose}>
                <h2>Verificação</h2>
                <p>Tem certeza que deseja duplicar esse registro?</p>

                <div className="row">
                  <div className="col-12 mt-3 d-flex justify-content-end">
                    <button
                      className="btn btn-primary me-2"
                      onClick={handleCloneConfirma}
                    >
                      Sim
                    </button>
                    <button className="btn btn-danger" onClick={handleCloneClose}>
                      Não
                    </button>
                  </div>
                </div>
              </PopUp1>
            </div>

            <Modal
              isOpen={showform}
              onRequestClose={closeModal}
              overlayClassName="modal-overlay"
              className="modal-content"
            >
              <div className="container-fluid h-100">
                <div className="row">
                  <h2>Novo Cadastro</h2>
                </div>
                <div className="row">
                  <hr />
                </div>

                <div className="row">
                  <form>
                    <div className="row">
                      <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                        <label htmlFor="supervisor" className="form-label">
                          Gestor
                        </label>
                        <select
                          id="supervisor"
                          className="form-select"
                          value={codgestor}
                          onChange={(e) => setCodGestor(e.target.value)}
                        >
                          <option value="0">Escolha o supervisor</option>
                          {listaGestor.map(function (funcionario) {
                            return (
                              <option
                                key={funcionario.codcolaborador}
                                value={funcionario.codcolaborador}
                              >
                                {funcionario.nome}
                              </option>
                            );
                          })}
                        </select>
                      </div>

                      <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                        <label htmlFor="funcionario" className="form-label">
                          Profissional
                        </label>
                        <select
                          id="funcionario"
                          className="form-select"
                          value={codcolaborador}
                          onChange={(e) => setCodColaborador(e.target.value)}
                        >
                          <option value="0">Escolha o Profissional</option>
                          {listaColaborador.map(function (func) {
                            return (
                              <option
                                key={func.codcolaborador}
                                value={func.codcolaborador}
                              >
                                {func.nome}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12">
                        <label htmlFor="titulo" className="form-label">
                          Equipe
                        </label>
                        <select className="form-select" value={edtcodequipe || '0'} onChange={handleEquipeChange}>
                          <option value="0">Selecione a equipe</option>
                          {listaequipe.map((eq, index) => (
                            <option key={index} value={eq.codequipe}>{eq.descricao}</option>
                          ))}
                        </select>
                      </div>

                      <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12">
                        <label htmlFor="titulo" className="form-label">
                          Setor
                        </label>
                        <select className="form-select" value={edtcodsetor || '0'} onChange={handleSetorChange}>
                          <option value="0">Selecione o setor</option>
                          {listasetor.map((set, index) => (
                            <option key={index} value={set.codsetor}>{set.descricao}</option>
                          ))}
                        </select>
                      </div>

                      <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12">
                        <label htmlFor="titulo" className="form-label">
                          Função
                        </label>
                        <select className="form-select" value={edtcodfuncao || '0'} onChange={handleFuncaoChange}>
                          <option value="0">Selecione a função</option>
                          {listafuncao.map((fun, index) => (
                            <option key={index} value={fun.codfuncao}>{fun.descricao}</option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-xl-3 col-lg-3 col-md-12 col-sm-12">
                        <label htmlFor="tipoperiodicidade" className="form-label">
                          Tipo Periodicidade
                        </label>
                        <select
                          id="tipoperiodicidade"
                          className="form-select"
                          value={tipoperiodicidade}
                          onChange={(e) => setTipoPeriodicidade(e.target.value)}
                        >
                          <option value="">Escolha a Periodicidade</option>
                          <option value="Diário">Diário</option>
                          <option value="Semanal">Semanal</option>
                          <option value="Quinzenal">Quinzenal</option>
                          <option value="Mensal">Mensal</option>
                          <option value="Bimestral">Bimestral</option>
                          <option value="Trimestral">Trimestral</option>
                          <option value="Semestral">Semestral</option>
                          <option value="Anual">Anual</option>
                        </select>
                      </div>

                      <div className="col-xl-3 col-lg-3 col-md-12 col-sm-12">
                        <label htmlFor="dttarefa" className="form-label">
                          Dt. Tarefa
                        </label>
                        <input
                          type="date"
                          name="dttarefa"
                          id="dttarefa"
                          className="form-control"
                          value={dttarefa}
                          onChange={(e) => setDtTarefa(e.target.value)}
                        />
                      </div>

                      <div className="col-xl-2 col-lg-2 col-md-12 col-sm-12">
                        <label htmlFor="diastolerancia" className="form-label">
                          Dias Tolerância
                        </label>
                        <input
                          type="text"
                          name="diastolerancia"
                          id="diastolerancia"
                          className="form-control"
                          value={diastolerancia}
                          onChange={(e) => setDiasTolerancia(e.target.value)}
                        />
                      </div>

                      <div className="col-xl-2 col-lg-2 col-md-12 col-sm-12">
                        <label htmlFor="qtdetarefa" className="form-label">
                          Qtde Repetir
                        </label>
                        <input
                          type="text"
                          name="qtdetarefa"
                          id="qtdetarefa"
                          className="form-control"
                          value={qtdetarefa}
                          onChange={(e) => setQtdeTarefa(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-xl-2 col-lg-2 col-md-12 col-sm-12">
                        <label htmlFor="coinssomar" className="form-label">
                          Coins Somar
                        </label>
                        <input
                          type="text"
                          name="coinssomar"
                          id="coinssomar"
                          className="form-control"
                          value={coinssomar}
                          onChange={(e) => setCoinsSomar(e.target.value)}
                        />
                      </div>

                      <div className="col-xl-2 col-lg-2 col-md-12 col-sm-12">
                        <label htmlFor="coinssubtrair" className="form-label">
                          Coins Subtrair
                        </label>
                        <input
                          type="text"
                          name="coinssubtrair"
                          id="coinssubtrair"
                          className="form-control"
                          value={coinssubtrair}
                          onChange={(e) => setCoinsSubtrair(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                        <label htmlFor="tarefa" className="form-label">
                          Tarefa
                        </label>
                        <textarea
                          className="form-control"
                          name="tarefa"
                          id="tarefa"
                          rows="3"
                          value={tarefa}
                          onChange={(e) => setTarefa(e.target.value)} />
                      </div>
                    </div>
                  </form>
                </div>

                <div className="row">
                  <div className="col-12 mt-3 d-flex justify-content-end">
                    <button className="btn btn-danger ms-4" onClick={closeModal}>
                      Cancelar
                    </button>
                    <button className="btn btn-success ms-4" onClick={Salvar}>
                      Salvar
                    </button>
                  </div>
                </div>
              </div>
            </Modal>
          </div>

          <div className="row">
            <h1 className="ms-4">Cadastro de CheckList</h1>
            <p className="ms-4">Rotina para cadastrar as tarefas dos profissionais</p>
            <hr />
          </div>

          <div className="row">
            <div className="col-6">
              <label className="form-label" htmlFor="busca">
                Busque aqui
              </label>
              <input
                type="text"
                placeholder="Buscar por: Código, Gestor ou profissional"
                name="busca"
                id="busca"
                className="form-control"
                value={abusca}
                onChange={(e) => setabusca(e.target.value)}
              />
            </div>
            <div className="col-2">
              <label htmlFor="dt1" className="form-label">
                De...
              </label>
              <input
                type="date"
                id="dt1"
                className="form-control"
                placeholder="Dt. Lançamento"
                value={dt1}
                onChange={(e) => setdt1(e.target.value)}
              />
            </div>

            <div className="col-2">
              <label htmlFor="dt2" className="form-label">
                Para...
              </label>
              <input
                type="date"
                id="dt2"
                className="form-control"
                placeholder="Dt. Lançamento"
                value={dt2}
                onChange={(e) => setdt2(e.target.value)}
              />
            </div>

            <div className="col-2 d-flex justify-content-center">
              <button
                className="btn btn-success btnnovo"
                onClick={() => openModalNovo()}
              >
                Novo
              </button>
            </div>
          </div>

          <div className="row mt-3">
            <hr />
          </div>

          {selectedItems.length > 0 && (
            <div className="mb-3 d-flex justify-content-end">
              <button className="btn btn-danger" onClick={ExcluirSelecionados}>
                Excluir Selecionados ({selectedItems.length})
              </button>
            </div>
          )}


          <div className="row">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>
                    <input
                      type="checkbox"
                      checked={selectedItems.length === lista.length && lista.length > 0}
                      onChange={handleSelectAll}
                    />
                  </th>
                  <th>Código</th>
                  <th>Lançamento</th>
                  <th>Gestor</th>
                  <th>Profissional</th>
                  <th>Dt. Tarefa</th>
                  <th>Tarefa</th>
                  <th className="acao">Ações</th>
                </tr>
              </thead>
              <tbody>
                {lista.map((item) => (
                  <tr key={item.codchecklist}>
                    <td>
                      <input
                        type="checkbox"
                        checked={selectedItems.includes(item.codchecklist)}
                        onChange={() => handleCheckboxChange(item.codchecklist)}
                      />
                    </td>
                    <td>{item.codchecklist}</td>
                    <td>{FormataDataHora(item.dtlancamento)}</td>
                    <td>{item.gestor}</td>
                    <td>{item.colaborador}</td>
                    <td>{FormataData(item.dttarefa)}</td>
                    <td>{item.tarefa}</td>
                    <td>
                      <div className="d-flex justify-content-center">
                        <button
                          className="btn fa-solid fa-trash"
                          onClick={() => handleOpen(item)}
                        ></button>
                        <button
                          className="btn fa-solid fa-clone"
                          onClick={() => handleCloneOpen(item)}
                        ></button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <th colSpan={8}>
                    Quantidade de Registros: {lista.length}
                  </th>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}

export default CadCheckList;
